<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="8"
        sm="4"
      >
        <v-card outlined>
          <v-card-text>
            <v-row v-if="!('id' in item)">
              <v-col
                cols="12"
                md="12"
              >
                <v-autocomplete
                  v-model="supplier"
                  :items="suppliers"
                  item-text="firstName"
                  hide-details="auto"
                  return-object
                  outlined
                  label="Select Products Supplier"
                  @change="loadSupplierProduct"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="item.name"
                  hide-details="auto"
                  label="Name"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="item.cost"
                  hide-details="auto"
                  label="Cost"
                  outlined
                  autofocus
                  type="number"
                  dense
                />
              </v-col>

              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="item.qty"
                  hide-details="auto"
                  label="QTY"
                  outlined
                  type="number"
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="1"
              >
                <v-btn
                  color="info"
                  :disabled="!item.qty || !item.cost || !item.name"
                  @click="setProduct"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Remove
                    </th>
                    <th class="text-left">
                      SKU
                    </th>
                    <th class="text-left">
                      Item
                    </th>
                    <th class="text-left">
                      Cost
                    </th>
                    <th class="text-left">
                      QTY
                    </th>
                    <th class="text-left">
                      Sub Total
                    </th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="product in products"
                    :key="product.id"
                  >
                    <td>
                      <v-icon
                        small
                        color="red"
                        @click="unsetProduct(product)"
                      >
                        mdi-delete
                      </v-icon>
                    </td>
                    <td>{{ product.sku }}</td>
                    <td>{{ product.name | capitalize }}</td>
                    <td>{{ product.cost | currency }}</td>
                    <td>{{ product.qty }}</td>
                    <td>{{ product.subTotal | currency }}</td>
                    <td>
                      <v-icon
                        small
                        color="info"
                        @click="editInfo(product)"
                      >
                        mdi-pencil
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
      >
        <v-card outlined>
          <v-card-text class="px-0">
            <v-checkbox
              v-model="order.method"
              class="ml-6"
              :label="order.method ? 'On credit' : 'With cash'"
            />

            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.reference"
                hide-details="auto"
                label="Reference"
                outlined
                dense
              />
            </v-col>
            <v-col
              v-if="order.method"
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.dueDate"
                hide-details="auto"
                label="Due Date"
                outlined
                type="date"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.discountRate"
                hide-details="auto"
                label="Discounted Rate %"
                outlined
                type="number"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.taxRate"
                hide-details="auto"
                label="Tax Rate %"
                outlined
                type="number"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="order.shippingAmount"
                hide-details="auto"
                label="Shipping Charges"
                outlined
                type="number"
                dense
              />
            </v-col>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          class="mt-4 px-0"
        >
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total QTY:</td>
                    <td>{{ order.totalItems }}</td>
                  </tr>
                  <tr>
                    <td>Total:</td>
                    <td>{{ order.subTotal | currency }}</td>
                  </tr>
                  <tr>
                    <td>After Discount (-){{ discountedAmount }}:</td>
                    <td>
                      {{ afterDiscount | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>With Tax (+){{ taxAmount }}:</td>
                    <td>
                      {{ withTax | currency }}
                    </td>
                  </tr>
                  <tr>
                    <th>Total Amount (Payable):</th>
                    <td>
                      {{ totalAmount | currency }}
                    </td>
                  </tr>

                  <tr>
                    <td>Excluded Shipping:</td>
                    <td>{{ order.shippingAmount | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <div class="text-center">
          <v-btn
            color="green"
            class="ma-2 white--text"
            :disabled="checking"
            @click="createPurchase"
          >
            Save
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            :to="{ name: 'PurchaseTransaction' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      order: {
        reference: new Date(),
        purchasing: true,
        totalItems: 0,
        subTotal: 0,
        taxRate: 0,
        discountRate: 0,
        shippingAmount: 0,
        method: false,
        dueDate: new Date().toISOString().substr(0, 10),
      },

      suppliers: [],
      supplier: [],
      products: [],
      item: {},
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
    checking() {
      let value = false;
      this.$data.products.forEach((item) => {
        if (!item.subTotal) {
          value = true;
        }
      });
      return value;
    },
    discountedAmount() {
      let discountRate = this.$data.order.discountRate ?? 0;
      let subTotal = this.$data.order.subTotal ?? 0;
      return subTotal * (discountRate / 100);
    },
    taxAmount() {
      let taxRate = this.$data.order.taxRate ?? 0;
      let amount = this.$data.order.subTotal ?? 0;
      return amount * (taxRate / 100);
    },
    afterDiscount() {
      return this.$data.order.subTotal - this.discountedAmount;
    },
    withTax() {
      return this.afterDiscount + this.taxAmount;
    },
    totalAmount() {
      return this.withTax;
    },
  },
  watch: {
    products() {
      this.order.totalItems = 0;
      this.order.subTotal = 0;
      this.products.forEach((product) => {
        if ("qty" in product) {
          this.order.totalItems += Number(product.qty);
        }
        if ("subTotal" in product) {
          this.order.subTotal += Number(product.subTotal);
        }
      });
    },
  },
  mounted() {
    this.getFromApi();
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    editInfo(product) {
      if (!("id" in this.$data.item)) {
        this.unsetProduct(product);
        this.$data.item = product;
      }
    },
    unsetProduct(product) {
      let list = this.$data.products;
      list.splice(list.indexOf(product), 1);
    },
    setProduct() {
      this.$data.item.subTotal = this.$data.item.cost * this.$data.item.qty;
      this.$data.products.push(this.$data.item);
      this.$data.item = {};
    },

    redirect(info) {
      this.feedback(info.data.message);
      this.$router.push({
        name: "PrintPurchase",
        params: { id: info.data.id },
      });
    },

    prepairData() {
      this.$data.order.discountedAmount = this.discountedAmount;
      this.$data.order.taxAmount = this.taxAmount;
      this.$data.order.totalAmount = this.totalAmount;
      this.$data.order.items = this.$data.products;
      return this.$data.order;
    },
    createPurchase() {
      window.axios.post("/purchase", this.prepairData()).then((response) => {
        this.redirect(response);
      });
    },

    loadSupplierProduct() {
      this.$data.order.supplier_id = this.$data.supplier.id;
      this.$data.products = this.$data.supplier.products;
    },
    getFromApi() {
      window.axios.get("/product-form-data").then((response) => {
        this.suppliers = response.data.suppliers;
      });
    },
  },
};
</script>
